import { List, Map } from 'immutable';

import { IQueueEffectPayload, ISomeEffect } from '../../types';

import { composeSubscriber } from '../module';

import { selectEffectSubscriberProps } from './effectSelectors';
import { effectActionCreators } from './effectState';

export const startEffect = async (
  effect: ISomeEffect,
  payload: IQueueEffectPayload<any, any, any>,
  state: Map<string, any>
): Promise<any> => {
  switch (effect.effectKind) {
    case 'effect':
      return effect.run(payload.effect);
    case 'payloadlessEffect':
      return effect.run();
    case 'statefulEffect':
      return effect.run(effect.selector(state), payload.effect);
    case 'statefulPayloadlessEffect':
      return effect.run(effect.selector(state));
    default:
      return Promise.resolve();
  }
};

export function composeEffectHandler(effects: Map<string, ISomeEffect>) {
  return (queuedEffects: List<IQueueEffectPayload<any, any, any>>, state: Map<string, any>) => {
    effectActionCreators.removeFromQueue(queuedEffects.toArray());
    queuedEffects.forEach(effectPayload => {
      const effect = effects.get(effectPayload.effectType);

      startEffect(effect, effectPayload, state)
        .then(effectPayload.resolve)
        .catch(effectPayload.reject);
    });
  };
}

export function effectSubscriber(effects: Map<string, ISomeEffect>) {
  const effectHandler = composeEffectHandler(effects);
  return composeSubscriber({
    selector: selectEffectSubscriberProps,
    onChange: ({ queuedEffects, state }) => {
      if (queuedEffects.size < 1) {
        return;
      }

      effectHandler(queuedEffects, state);
    }
  });
}
